import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik, Form, FormikProvider } from "formik";
import styled from "@emotion/styled";
import {
  Checkbox,
  Button,
  MenuItem,
  TextField as MuiTextField,
  ListItemText,
  Grid,
} from "@mui/material";
import { spacing } from "@mui/system";
import useNotification from "hooks/useNotification";
import useReferentiel from "hooks/useReferentiel";
import useAppmedia from "hooks/useAppmedia";
import AudioBoxFromUrl from "components/media/AudioBoxFromUrl";
import { getMediaUrl } from "utils/objectUtil";
// ----------------------------------------------------------------------
const TextField = styled(MuiTextField)(spacing);
export default function AppMusicForm({ editData, onComplete, refName }) {
  const { refs } = useReferentiel();
  const { saveAppMedia, getAppMusics } = useAppmedia();
  const { notif } = useNotification();
  const dataSchema = Yup.object().shape({
    name: Yup.string()
      .max(20)
      .required("Veuillez renseigner le nom du fichier"),
    refthememedia: Yup.string().required(
      "Veuillez renseigner le thème de musique"
    ),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: editData && editData.name ? editData.name : "",
      refthememedia:
        editData && editData.refthememedia ? editData.refthememedia : "",
    },
    validationSchema: dataSchema,
    onSubmit: async () => {
      try {
        const newData =
          editData && editData.id ? { ...editData, ...values } : { ...values };
        await saveAppMedia(
          {
            ...newData,
          },
          refName
        );
        await getAppMusics();
        notif("Sauvegarde réussie");
        onComplete();
      } catch (error) {
        console.error(error);
        notif(null, error);
        setSubmitting(false);
      }
    },
  });

  const {
    errors,
    touched,
    values,
    isSubmitting,
    handleSubmit,
    handleChange,
    getFieldProps,
    setSubmitting,
  } = formik;
  if (!refName) return <></>;
  if (!refs) return <></>;
  const { refthememedia } = refs;
  if (!refthememedia) return <></>;
  console.log(refthememedia);
  return (
    <Grid container sx={{ width: "100%" }} spacing={4}>
      <Grid item xs={12} sm={8} md={6}>
        <AudioBoxFromUrl audio={getMediaUrl(editData, "filepath", refName)} />
      </Grid>
      <Grid item xs={12} sm={4} md={6}>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <TextField
              fullWidth
              type="text"
              label="Nom du fichier"
              {...getFieldProps("name")}
              error={Boolean(touched.name && errors.name)}
              helperText={touched.name && errors.name}
              my={2}
            />
            <TextField
              fullWidth
              select
              label="Thème de musique"
              value={values.refthememedia}
              onChange={handleChange("refthememedia")}
              {...getFieldProps("refthememedia")}
              error={Boolean(touched.refthememedia && errors.refthememedia)}
              helperText={touched.refthememedia && errors.refthememedia}
              my={2}
            >
              {refthememedia.map((option, i) => (
                <MenuItem key={i} value={option.id}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            <Button
              sx={{ my: 2 }}
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              disabled={isSubmitting}
            >
              Valider
            </Button>
          </Form>
        </FormikProvider>
      </Grid>
    </Grid>
  );
}
